import React, { Component } from 'react';
import { Layout, Menu, Icon, Button, Descriptions, Select} from 'antd';

const { Header, Content, Footer, Sider } = Layout;

const { Option } = Select;

class ReviewImages2 extends Component {

  handleChange = async(e, item, index) => {
    this.props.updateImage(e, item, index)
  }

  render() {
    return (
      <div>
        <h2>Review & Update Classification Predictions</h2>

        <div style={{ margin: 5, padding: 24, background: '#fff', display: 'flex', flexDirection: 'column'}}> 
          {this.props.linkArray.map((item, i) => {
            // let itemKeys = []
            // if(item.feedback.other) {
            //   itemKeys = Object.keys(item.feedback.other)
            // } 
            return (
              <div key={i} style={{display: 'flex', marginBottom: 12}}>
                <div style={{ margin: 5,}} >         
                  <img style={{ maxWidth: 400 }} src={item.feedback.src} />
                </div>
                <div style={{ margin: 5,}} >
                  <div>
                    <p>Show the "other" property</p>
                    {item.feedback.other && item.feedback.other.map((object, j) => {
                      let keyArray = Object.keys(object)
                      return (keyArray.map((key, k) => {
                        return (<p key={i+j+k+key}><b>{key}:</b>{item.feedback.other[j][key]}</p>)
                      }))
                    })}
                    <Select 
                      defaultValue={item.feedback.winner && item.feedback.winner} 
                      style={{ width: 120, marginBottom: 12 }} 
                      onChange={(e) => this.handleChange(e, item, i)}
                    >   
                      {this.props.labels.map((label) => {
                        return (
                          <Option value={label}>{label}</Option> 
                        )
                      })}                    
                    </Select>  
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    );
  }
}

export default ReviewImages2;